import { PlayerWithPerformance } from '../types/database';

export function getLastMatchLabel(p: PlayerWithPerformance): string | null {
  const all = [
    ...(p.battingInnings ?? []).map(e => ({ label: e.matchLabel, date: e.date })),
    ...(p.bowlingSpells ?? []).map(e => ({ label: e.matchLabel, date: e.date })),
    ...(p.fieldingPerformances ?? []).map(e => ({ label: e.matchLabel, date: e.date })),
  ].filter(e => !!e.label);
  if (!all.length) return null;
  all.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  return all[0].label ?? null;
}

export function getLastMatchPoints(p: PlayerWithPerformance): number {
  const label = getLastMatchLabel(p);
  if (!label) return 0;
  const bat   = (p.battingInnings ?? []).filter(e => e.matchLabel === label).reduce((s, e) => s + e.pointsEarned, 0);
  const bowl  = (p.bowlingSpells ?? []).filter(e => e.matchLabel === label).reduce((s, e) => s + e.pointsEarned, 0);
  const field = (p.fieldingPerformances ?? []).filter(e => e.matchLabel === label).reduce((s, e) => s + e.pointsEarned, 0);
  return bat + bowl + field;
}

export function shouldShowRemoveButton(readOnly: boolean, _isSubmitted: boolean): boolean {
  return !readOnly;
}
